_isEmpty = require('lodash-es/isEmpty').default
_take = require('lodash-es/take').default
_reduce = require('lodash-es/reduce').default

removePunctuation = (string) ->
  string.replace(/[.,-\/#!$%\^&\*;:{}=\-_`~()]/g,'')

removeExtraSpaces = (string) ->
  string.replace(/\s+/g, ' ')

isEndUser = (customer) -> !!customer.socialProfile

isLeadEndUser = (customer) -> isEndUser(customer) and customer.type is 'LEAD'

isCompany = (customer) -> !!customer.companyProfile

isCustomer = (customer) -> customer.socialProfile or customer.companyProfile

getDisplayName = (customer) ->
  if (!customer)
    return ''

  displayName = customer.name or customer.email
  if displayName
    return displayName
  if isLeadEndUser(customer)
    return 'Site Visitor'
  return customer.externalId

getInitials = (customer) ->
  return if _isEmpty(customer)
  display = getDisplayName(customer)
  return if _isEmpty(display)

  trimmedName = removeExtraSpaces(removePunctuation(display.trim()))
  _reduce trimmedName.split(' ').splice(0, 3), ((acc, n) ->
    if n
      acc + _take(n, 1)
    else
      acc
  ), ''

module.exports = {
  isEndUser
  isLeadEndUser
  isCompany
  isCustomer
  getDisplayName
  getInitials
}



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/helpers/CustomerHelpers.coffee